import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import _WidgetBaseSP from 'more/_WidgetBaseSP';

import domConstruct from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import template from './EventBookingEdit.html?raw';
import query from 'dojo/query';
import EventCommentsList from '../EventCommentsList/EventCommentsList';
import "../HintBox/HintBox"; // more/Legacy/Zal/HintBox/HintBox — template-only (data-dojo-type in EventBookingEdit.html); bare import force-keeps it.
import "../../FileTransfer/Uploader/Uploader"; // more/Legacy/FileTransfer/Uploader/Uploader — template-only (data-dojo-type in EventBookingEdit.html); bare import force-keeps it.
import GenericDialog from '../../GenericDialog/GenericDialog';
import "../../../../WidgetCollection/ZAL/Eve/Home/Home"; // WidgetCollection/ZAL/Eve/Home/Home — non-dojo dep, only referenced in commented-out code; bare import preserves it.
// JS2TS: dropped dep BookingNonComplexModificationDialog — referenced in the original define() but no such module exists in the repo (dead reference).

class EventBookingEdit extends compose(_WidgetBaseSP) {
    [key: string]: any;
    templateString: any = template;
    entity: any = null;
    commentList: any = null;
    editMode = false;

    editingTimeLimit_hours = 25;
    editingTimeLimit_date: any = null;


    _checkUndefined(value: any, forceNull?: any) {
        if (typeof (value) == "undefined") {
            if (typeof (forceNull) != "undefined") {
                return null;
            }
            return "";
        }

        return value;
    }

    _loadEntityValues() {

        if (this.entity == null) {
            return;
        }

        if (this.entity.isDigitalOnly === true) {
            this.date1_container.dataset["evisformatter"] = "_dateTimeFormatter";
            this.date2_container.dataset["evisformatter"] = "_dateTimeFormatter";
        }

        //  Textfelder befüllen - alle Inputs mit "data-evisattribute"
        //
        var inputs: any = query("[data-evisattribute]", this.domNode);
        for (var i = 0; i < inputs.length; i++) {
            var input = inputs[i];
            var widget = (window as any).dijit.registry.byNode(input);
            if (widget == null) {
                if (typeof (input.dataset["evisformatter"]) == "string") {
                    var valueRaw = this.PitHelper.getEntityAttributeValue(this.entity, input.dataset["evisattribute"], "json");
                    var valueFormatted = this._checkUndefined(this[input.dataset["evisformatter"]](valueRaw));

                    domAttr.set(input, "innerHTML", valueFormatted);
                } else {
                    domAttr.set(input, "innerHTML", this._checkUndefined(this.PitHelper.getEntityAttributeValue(this.entity, input.dataset["evisattribute"], "json")));
                }
            } else {
                if (typeof (input.dataset["evisformatter"]) == "string") {
                    var valueRaw = this.PitHelper.getEntityAttributeValue(this.entity, input.dataset["evisattribute"], "json");
                    var valueFormatted = this._checkUndefined(this[input.dataset["evisformatter"]](valueRaw), true);
                    widget.set("value", valueFormatted);
                } else {
                    //console.log("_loadEntityValues", input.dataset["evisattribute"], this.PitHelper.getEntityAttributeValue(this.entity, input.dataset["evisattribute"], "json"));
                    widget.set("value", this._checkUndefined(this.PitHelper.getEntityAttributeValue(this.entity, input.dataset["evisattribute"], "json"), true));
                }
            }
        }



        this.logic__CheckWriteableVisible();
        this.logic_OnEntityLoaded();
    }

    _onChange_PrincipalList(uploadIdentifier: any) {
        console.log("_onChange_PrincipalList", uploadIdentifier);

        this.StandbyStart();

        this.RequestManager.post(window.appRoot + "Zal/SaveParticipantList",
            {
                "JsonData": JSON.stringify({
                    BookingID: this.entity.ID,
                    UploadIdentifier: uploadIdentifier
                })
            },
            lang.hitch(this, "_onSaveParticipantList_Response"),
            lang.hitch(this, "_onSaveParticipantList_Error")
        );
    }

    _onSaveParticipantList_Response(response: any) {
        this.entity = response;
        this._loadEntityValues();

        this.StandbyStop();
    }
    _onSaveParticipantList_Error(error: any) {
        this.StandbyStop();
    }

    _onClick_EditSubstitute() {
        domClass.remove(this.substituteHintBox.domNode, "w3-hide");
        domClass.add(this.substituteLabel, "w3-hide");

        domClass.add(this.editSubstituteBtn, "w3-hide");
        domClass.remove(this.saveSubstituteBtn, "w3-hide");
    }

    _onClick_EditSubstitute__Save() {

        this.StandbyStart();

        var selectedValue = this.substituteHintBox.get("value");
        var subID = null;
        if (selectedValue != null) {
            subID = selectedValue.ID;
        }

        this.RequestManager.post(window.appRoot + "Zal/SaveSubstitute",
            {
                "JsonData": JSON.stringify({
                    BookingID: this.entity.ID,
                    SubstituteID: subID
                })
            },
            lang.hitch(this, "_onSaveSubstitute_Response"),
            lang.hitch(this, "_onSaveSubstitute_Error")
        );

    }

    _onSaveSubstitute_Response(response: any) {
        this.StandbyStop();

        this.entity = response;
        this._loadEntityValues();

        domClass.add(this.substituteHintBox.domNode, "w3-hide");
        domClass.remove(this.substituteLabel, "w3-hide");

        domClass.remove(this.editSubstituteBtn, "w3-hide");
        domClass.add(this.saveSubstituteBtn, "w3-hide");
    }

    _onSaveSubstitute_Error(error: any) {
        this.StandbyStop();
        alert(error.Message);
    }

    logic__CheckWriteableVisible() {

        domClass.remove(this.participantRow, "w3-hide"); // eigentlich immer anzeigen falls icht explizit ausgeschaltet

        if (this.entity.is_eventtype_external == true) {
            domClass.remove(this.daterow_external, "w3-hide");
            domClass.add(this.officialsRow, "w3-hide");
            domClass.remove(this.participantRow, "w3-hide");
        } else if (this.entity.is_eventtype_internal == true) {
            domClass.add(this.daterow_external, "w3-hide");
            domClass.remove(this.officialsRow, "w3-hide");
            domClass.remove(this.participantRow, "w3-hide");
        } else if (this.entity.isDigitalOnly == true) { // meaning: is_eventtype_remote == true ... hat sich historisch so entwickelt ...
            domClass.remove(this.daterow_external, "w3-hide");
            domClass.add(this.officialsRow, "w3-hide");
            //domClass.add(this.participantRow, "w3-hide");
        }

        if (this.entity.is_eventtype_internal === true) {
            domClass.add(this.selectedLanguages_container, "w3-hide");

            domClass.add(this.activity_remote, "w3-hide");
            domClass.remove(this.seating_container, "w3-hide");
            if (this.entity.ref_vt_service && this.entity.ref_vt_service["Classname"] == "service_ev_room_group") {
                domClass.add(this.location_external, "w3-hide");
                domClass.remove(this.location_internal_roomGroup, "w3-hide");
                domClass.add(this.location_internal, "w3-hide");

            } else {
                domClass.add(this.location_external, "w3-hide");
                domClass.add(this.location_internal_roomGroup, "w3-hide");
                domClass.remove(this.location_internal, "w3-hide");

            }


        } else if (this.entity.is_eventtype_external === true) {
            domClass.add(this.selectedLanguages_container, "w3-hide");

            domClass.remove(this.location_external, "w3-hide");
            domClass.add(this.location_internal, "w3-hide");
            domClass.add(this.activity_remote, "w3-hide");
            domClass.add(this.location_internal_roomGroup, "w3-hide");
            domClass.remove(this.seating_container, "w3-hide");
            domClass.add(this.tmp_services_container, "w3-hide");
            domClass.add(this.catering_container, "w3-hide");
            domClass.add(this.seating_container, "w3-hide");

            if (this.entity.ref_booking_status.ID == GP.ID_booking_status_event_booked.ID) {
                domClass.add(this.location_external, "w3-hide");
                domClass.remove(this.location_internal_fixed, "w3-hide");

                domClass.add(this.daterow_external, "w3-hide");
            }

        } else if (this.entity.isDigitalOnly == true) { // == is_eventtype_remote == true : hat sich historisch so entwickelt ...

            domClass.remove(this.selectedLanguages_container, "w3-hide");
            var displayText = "";

            if (this.entity.remote_event_language_de) displayText = displayText + this.translations["EventBookingRemote__NecessaryInfo_SelectLanguageLabel_de"] + "<br>";
            if (this.entity.remote_event_language_en) displayText = displayText + this.translations["EventBookingRemote__NecessaryInfo_SelectLanguageLabel_en"] + "<br>";
            domAttr.set(this.selectedLanguages, "innerHTML", displayText);

            domAttr.set(this.location_label_container, "innerHTML", this.translations["EventBookingEdit_LocationLable_remote"]);
            domClass.add(this.seating_container, "w3-hide");

            domClass.add(this.location_external, "w3-hide");
            domClass.add(this.location_internal, "w3-hide");
            domClass.add(this.location_internal_roomGroup, "w3-hide");
            domClass.add(this.tmp_services_container, "w3-hide");
            domClass.add(this.catering_container, "w3-hide");
            domClass.remove(this.activity_remote, "w3-hide");

            var innerHTML_text = "";

            if (this.entity.EL_vt_pos_ev_vt_event_planning && this.entity.EL_vt_pos_ev_vt_event_planning.length) {

                for (var i = 0; i < this.entity.EL_vt_pos_ev_vt_event_planning.length; i++) {
                    if (this.entity.EL_vt_pos_ev_vt_event_planning[i].ref_vt_service) {

                        if (this.entity.EL_vt_pos_ev_vt_event_planning[i].ref_vt_service.description) {
                            innerHTML_text = innerHTML_text + this.entity.EL_vt_pos_ev_vt_event_planning[i].ref_vt_service.description + "<br>";
                        } else if (this.entity.EL_vt_pos_ev_vt_event_planning[i].ref_vt_service.description_D) {
                            innerHTML_text = innerHTML_text + this.entity.EL_vt_pos_ev_vt_event_planning[i].ref_vt_service.description_D + "<br>";
                        } else {
                            innerHTML_text = innerHTML_text + "Error: no activity description." + "<br>";
                        }
                    }
                }
            }

            domAttr.set(this.activity_remote, "innerHTML", innerHTML_text);
        }

        // bei den externen und digitalen events haben wir kein date start, dafür aber optionale dates. wenn eine davon in vergangenheit liegt, soll nicht gecancelt werden
        var smallestDate = this.entity.date_start;
        var now = new Date();

        if (!this.entity.date_start) {
            smallestDate = this.entity.date_1;
            if (this.entity.date_2 && this.entity.date_2 < smallestDate) smallestDate = this.entity.date_2;
        }

        var date_start = new Date(smallestDate.valueOf());

        if (date_start.getTime() < now.getTime()) {
            domClass.add(this.cancelButton, "w3-hide"); // buchung ist bereits vorbei
            return;
        }

        if (this.entity.ref_booking_status.ID == GP.ID_booking_status_cancelled.ID) {
            domClass.add(this.cancelButton, "w3-hide"); // buchung ist bereits gecancelt
            return;
        }

        if (this.entity.tmp_is_with_catering === true) {
            domClass.add(this.cancelButton, "w3-hide"); // ohne catering darf man immer stornieren
            return;
        }

        var forerun = 72 * 60; // stunden zu minuten
        forerun = forerun * 60000; // minuten zu millisekunden

        var dateWithForerun = new Date(date_start.getTime() - forerun); // liegt in der Vergangenheit

        if (now.getTime() >= dateWithForerun.getTime()) {
            domClass.add(this.cancelButton, "w3-hide");
        }

    }

    logic_OnEntityLoaded() {
        this.commentList = new (EventCommentsList as any)({
            bookingID: this.entity.ID
        });
        this.commentList.placeAt(this.domNode, "last");
        this.commentList.startup();
    }

    shown() {
        this.commentList.loadComments();

        this.emit("shown");
    }

    __cancelInProgress = false;

    _onClick_CopyBooking() {

        window.location.href = window.appRoot + "zal/eve?copyBooking=" + this.entity.ID;

        //var dlg = new GenericDialog({
        //    header: this.translations["EventBookingCopy_DlgTitle"],
        //    subTitle: this.translations["EventBookingCopy_DlgSubTitle"],
        //    destroyOnClose: false,
        //    closeOnEnter: false
        //});
        //
        //dlg.set("topCloseBtn", true);
        //
        //dlg.modalDlgContent.style.width = "90vw";
        //
        //
        ///*var form = new EventBookingCopyForm({
        //    sourceEntity: this.entity,
        //    editMode: false,
        //    dlg: dlg
        //});*/
        //
        //var form = new Home();
        //
        //dlg.set("ok", true);
        //dlg.addNodeToContent(form.domNode);
        //dlg.show();
        //
        //form.startup();
        //form._onClick__Internal();
    }

    _onClick_CancelBooking() {

        var warningDlg = new (GenericDialog as any)({
            header: this.translations["EventBookingEdit_CancelButton"],
            destroyOnClose: true,
            closeOnEnter: false
        });

        var messsageNode = domConstruct.create("div", {
            innerHTML: this.translations["MyBookings__bookingEdit_cancelConfirmMessage"],
            style: {
                fontWeight: "bold"
            }
        });

        warningDlg.set("topCloseBtn", true);

        console.log("WIDTH: ", window.innerWidth)

        if (window.innerWidth > 600) {
            domStyle.set(warningDlg.modalDlgContent, "max-width", "600px");
            domStyle.set(warningDlg.modalDlgContent, "margin-top", "15%");
            domStyle.set(warningDlg.modalDlgContent, "left", "50%");
            domStyle.set(warningDlg.modalDlgContent, "margin-left", "-300px");
        } else {
            domStyle.set(warningDlg.modalDlgContent, "width", "100%");
        }

        domStyle.set(warningDlg.textNode, "height", "auto");

        warningDlg.set("yes", true);
        warningDlg.set("back", true);
        warningDlg.addNodeToContent(messsageNode);
        warningDlg.on("close", lang.hitch(this, function (result) {
            if (result == 2) {
                this._cancelBooking();
            }
        }));
        warningDlg.show();

    }

    _cancelBooking() {

        if (this.__cancelInProgress === false) {
            this.__cancelInProgress = true;
            domClass.add(this.cancelButton, "w3-disabled");


            this.StandbyStart();
            this.RequestManager.post(
                (window as any).appRoot + "zal/CancelBooking",
                {
                    "JsonData": JSON.stringify({
                        ID: this.entity.ID
                    })
                },
                lang.hitch(this, "_onCancelBooking_Response"),
                lang.hitch(this, "_onCancelBooking_Error")
            );
        }

    }

    _onClick_EditBooking() {
        console.log("_onClick_EditBooking entity: ", this.entity)

        // JS2TS: BookingNonComplexModificationDialog module does not exist in the repo (its define() dep was a dead reference and was dropped). Preserved via (window as any) to keep 1:1 runtime intent — never fixed.
        let dlg = new (window as any).BookingNonComplexModificationDialog();
        dlg.open(this.entity);

        dlg.on("saved", lang.hitch(this, this._onBookingSavedAfterEdit));


    }

    _onBookingSavedAfterEdit(bookingEntity: any) {
        console.log("_onBookingSavedAfterEdit", bookingEntity);
        this.entity = bookingEntity;

        this._loadEntityValues();
    }

    _EditBookingWithPrimaryFields() {
        // eine Änderung die kritische Attriute wie Zeit, Raum, Personenanzahl, Typ benötigt (daher Storno und neu anlegen)
        //

        //console.log("_onClick_EditBooking entity: ", this.entity)


        var warningDlg = new (GenericDialog as any)({
            header: this.translations["EventBookingEdit_EditButton"],
            subTitle: this.translations["MyBookings__bookingEdit_warningText"],
            destroyOnClose: true,
            closeOnEnter: false
        });

        var messsageNode = domConstruct.create("div", {
            innerHTML: this.translations["MyBookings__bookingEdit_doYouWishToProceed"],
            style: {
                fontWeight: "bold"
            }
        });

        warningDlg.set("topCloseBtn", true);

        console.log("WIDTH: ", window.innerWidth)

        if (window.innerWidth > 600) {
            domStyle.set(warningDlg.modalDlgContent, "max-width", "600px");
            domStyle.set(warningDlg.modalDlgContent, "margin-top", "15%");
            domStyle.set(warningDlg.modalDlgContent, "left", "50%");
            domStyle.set(warningDlg.modalDlgContent, "margin-left", "-300px");
        } else {
            domStyle.set(warningDlg.modalDlgContent, "width", "100%");
        }

        domStyle.set(warningDlg.textNode, "height", "auto");

        warningDlg.set("yes", true);
        warningDlg.set("back", true);
        warningDlg.addNodeToContent(messsageNode);
        warningDlg.on("close", lang.hitch(this, function (result) {
            if (result == 2) {
                this._editBooking();
            }
        }));
        warningDlg.show();

    }


    _editBooking() {
        if (this.entity.date_start) {

            if (new Date(this.entity.date_start) > new Date() && !this.entity.is_locked) {
                this.editMode = true;
                this._cancelBooking();
            }

        } else if (new Date(this.entity.date_1) > new Date() && new Date(this.entity.date_2) > new Date() && new Date(this.entity.date_3) > new Date() && !this.entity.is_locked) { // extern

            if (this.entity.ref_booking_status.ID == "000002e5:00000002") {
                this.editMode = true;
                this._cancelBooking();
            }
        }
    }

    _onDlgClose(messageCode: any) {

        this.editMode = false;
        window.removeEventListener("beforeunload", this.beforeOnloadEventFunction);
    }

    // ---------------------- beforeunload event callback - nur während eine buchung modfiziert wird
    beforeOnloadEventFunction(event: any) {
        event.returnValue = "";
    }

    _onCancelBooking_Response(response: any) {

        this.StandbyStop();
        //alert("storno ok");
        this.emit("cancellationDone");
        this.__cancelInProgress = false;
        domClass.remove(this.cancelButton, "w3-disabled");

        if (this.editMode == true) {

            //window.addEventListener("beforeunload", this.beforeOnloadEventFunction);
            //
            //var dlg = new GenericDialog({
            //    header: this.translations["EventBookingEdit_DlgTitle"],
            //    subTitle: this.translations["EventBookingEdit_DlgSubTitle"],
            //    destroyOnClose: false,
            //    closeOnEnter: false
            //});
            //
            //on(dlg, "close", lang.hitch(this, "_onDlgClose"));
            //
            //console.log("_onClick_EditBooking booking:: ", this.entity)
            //
            //var form = new EventBookingCopyForm({
            //    sourceEntity: this.entity,
            //    editMode: true,
            //    dlg: dlg
            //});
            //
            //dlg.set("ok", true);
            //dlg.addNodeToContent(form.domNode);
            //dlg.show();

            window.location.href = window.appRoot + "zal/eve?copyBooking=" + this.entity.ID;

        }

    }

    _onCancelBooking_Error(error: any) {
        this.__cancelInProgress = false;
        domClass.remove(this.cancelButton, "w3-disabled");
        alert(error);
    }

    _NewlineToHtmlFormatter(value: any) {
        if (!value) {
            return "";
        }

        return value.replaceAll("\n", "</br>");
    }

    _dateFormatter(value: any) {
        if (!value) {
            return "";
        }
        var options: any = { year: 'numeric', month: '2-digit', day: '2-digit' };

        var date = new Date(value);
        return date.toLocaleDateString('de-DE', options);
    }

    _BoolToYesNoFormatter(value: any) {
        if (value == true) {
            return "Yes";
        }
        return "No";
    }

    _dateTimeFormatter(value: any) {
        if (!value) {
            return "";
        }
        var options: any = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };

        var date = new Date(value);
        return date.toLocaleDateString('de-DE', options);
    }
    _statusFormatter(value: any) {
        return "<span style=\"background-color: {0}; padding: 2px;\">{1}</span>".format(this.entity.ref_booking_status.tmp_css_color, value);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this._loadEntityValues();

        //console.log("ENTITY:: ", this.entity)

        // für xterne events wird copyBooking && editBooking gesperrt, da die copyBookingForm nur auf interne Buchungen ausgelegt ist.
        if (this.entity.selected_external_locations || this.entity.tmp_is_with_catering || this.entity.isDigitalOnly == true) {
            domStyle.set(this.editButton, "display", "none");
            domStyle.set(this.copyButton, "display", "none");
        }

        domAttr.set(this.participantListNotification, "innerHTML", (this.translations as any).EventBookingEdit_QtyPersonsExtWithLink);
        domAttr.set(this.externalGuestsLabel, "innerHTML", (this.translations as any).EventBookingEdit_ParticipantListLink);

        // bei den internen Buchungen wird eine editierung nur dann zugelassen, wenn das Buchungsstatus == "beauftragt" && !entity.is_locked

        //if (this.entity.ref_booking_status.ID == GP.ID_booking_status_ordered.ID && ((new Date().valueOf() + 1000 * 60 * 60 * this.editingTimeLimit_hours) < new Date(this.entity.date_start).valueOf())) {
        if (true) {

            if (this.entity.is_locked) {
                domStyle.set(this.editButton, "display", "none");
            }
        } else {
            domStyle.set(this.editButton, "display", "none");
        }

    }

}
EventBookingEdit.prototype.declaredClass = 'ZAL.EventBookingEdit.EventBookingEdit';

export default mdsWidget(EventBookingEdit);
